
import * as echarts from 'echarts';

// 例子
const option = {
  // 距离边框距离
  grid: {
    // 关键：把 bottom 调小，直接减少底部空白
    top: 70,    // 顶部留白（可根据需要调整）
    left: 20,   // 左侧留白
    right: 20,  // 右侧留白
    bottom: 0,  // 底部留白！设为0就能紧贴容器底部
    containLabel: true // 自动包含坐标轴标签，避免文字被裁
  },
  radius: "95%",
  // 悬停显示
  tooltip:{
    trigger: 'axis',
  },
  // X轴
  xAxis: {
    type: 'category',
    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  },
  // Y轴
  yAxis: {
    type: 'value',
    minInterval: 1,
  },
  // 颜色-内容
  legend: {
    top : 0,
    left: 20,
    selectedMode: false,
  },
  // 图表数据
  series: [
    {
      radius: "95%",
      name:"1",
      data: [120, 200, 150, 80, 70, 110, 130],
      type: 'bar',
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0, 0, 0, 1,  // 方向：从上到下
          [
            { offset: 0, color: 'rgba(80, 130, 222, 1)' },  // 顶部颜色
            { offset: 1, color: 'rgba(80, 130, 222, 0.35)' }   // 底部颜色
          ]
        )
      },
      
    },{
      radius: "95%",
      name:"2",
      data: [10, 20, 15, 8, 7, 11, 10],
      type: 'bar',
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0, 0, 0, 1,  // 方向：从上到下
          [
            { offset: 0, color: 'rgba(255, 165, 113, 1)' },  // 顶部颜色
            { offset: 1, color: 'rgba(249, 153, 74, 0.5)' }   // 底部颜色
          ]
        )
      },
    },
  ]
};
/*
  xNameList: [],
  dataList: [
    [],
    [],
  ],
  dataNames:[],
  colorList: [
    [],
    [],
  ],
*/
// 根据Max - Min 的位数 - 2的10次方(最小取10), 恒定切成5个间隔
export function getMinMaxInterval(list){
  // 获取最大最小值
  const sortList = [...list].sort((a,b) => a - b);
  const min = sortList[0];
  const max = sortList[list.length - 1];
  // 小于10的特殊处理
  if(max <= 10){
    return {
      min: 0,
      max: 10,
      interval: 2,
    }
  }
  // Max - Min => 1/10
  const pow = Math.pow(10, Math.max(String(max - min).length - 2, 1));
  const re_max = Math.ceil(max/pow)*pow;
  let re_min = Math.max(Math.floor(min/pow) - 5, 0)*pow; // 如果刻度大于0，则至少给最小值留有10%的高度
  return {
    min: re_min,
    max: re_max,
    interval: (re_max - re_min)/5
  }
}
export function getBar(xNameList, dataList, dataNames, colorList){
  const lineOpt = {
    ...option,
    xAxis:{
      type: 'category',
      data: xNameList,
    },
    yAxis: dataNames.map((i, index) => {
      var res = {
        type: 'value',
        name: i,
        scale: true,
        alignTicks: true,
        axisLine: { lineStyle: { color: colorList[index][0] } },
        ...getMinMaxInterval(dataList[index]),
      }
      if(index > 0){
        return {
          ...res,
          position: 'right', // 放右边
        }
      }
      return res
    }),

    series: dataList.map((i, index) => {
      return {
        name: dataNames[index],
        data: i,
        yAxisIndex: index,
        type: 'bar',
        itemStyle: {
          color: new echarts.graphic.LinearGradient(
          0, 0, 0, 1,  // 方向：从上到下
          [
            { offset: 0, color: colorList[index][0] },  // 顶部颜色
            { offset: 1, color: colorList[index][1] }   // 底部颜色
          ]
        ) 
        }
      }
    }),
  }
  return lineOpt
}